var path = '/opt/atlassian/pipelines/agent/build/src/app/common/app.html';
var html = "<div> <app-header user=$ctrl.user home-options=$ctrl.homeOptions role=$ctrl.role on-log-out=$ctrl.onLoggedOut()> </app-header> <div class=\"container body-container\"> <breadcrumb></breadcrumb> <div ui-view class=main-view></div> </div> <app-footer></app-footer> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app.html
// module id = 900
// module chunks = 0